var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DashboardHeader',{attrs:{"title":"Manage Staff"}},[_c('HRComponent',{attrs:{"branchID":null,"conferenceID":null},scopedSlots:_vm._u([{key:"calendar",fn:function(){return [_c('FullCalendar')]},proxy:true}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }